import { createThemedStyles } from "@/lib/functions/styles";
var stylesCreator = function (theme) {
    var _a;
    return ({
        toolbar: theme.mixins.toolbar,
        title: {
            marginTop: "5%",
        },
        emptyButton: (_a = {
                minWidth: "150px"
            },
            _a[theme.breakpoints.down("sm")] = {
                marginBottom: "5px",
            },
            _a[theme.breakpoints.up("xs")] = {
                marginRight: "20px",
            },
            _a),
        checkoutButton: {
            minWidth: "150px",
        },
        link: {
            textDecoration: "none",
        },
        cardDetails: {
            display: "flex",
            marginTop: "10%",
            width: "100%",
            justifyContent: "space-between",
        },
    });
};
export default createThemedStyles(stylesCreator);
